/**
 * Generated by orval 🍺
 * Do not edit manually.
 * RepeatMD.PatientApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DisplayListingLocationAvailability,
  DisplayPatientTreatmentBeforeAfterPairResponse,
  GetListingPackagesParams,
  GetListingParams,
  ListingMediaModel,
  ListingModel,
  PackageListingExpectationModel,
  PackageModel
} from '../model';

import { customAxios } from '../../custom-axios';
import type { ErrorType } from '../../custom-axios';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Returns a catalog listing for the current platform
 */
export const getListings = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ListingModel[]>(
      {url: `/api/v1/listings`, method: 'GET', signal
    },
      options);
    }




export const getGetListingsQueryKey = () => {
    return [
    `/api/v1/listings`
    ] as const;
    }


export const getGetListingsQueryOptions = <TData = Awaited<ReturnType<typeof getListings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListings>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetListingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getListings>>> = ({ signal }) => getListings(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getListings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetListingsQueryResult = NonNullable<Awaited<ReturnType<typeof getListings>>>
export type GetListingsQueryError = ErrorType<unknown>


export function useGetListings<TData = Awaited<ReturnType<typeof getListings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getListings>>,
          TError,
          Awaited<ReturnType<typeof getListings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetListings<TData = Awaited<ReturnType<typeof getListings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getListings>>,
          TError,
          Awaited<ReturnType<typeof getListings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetListings<TData = Awaited<ReturnType<typeof getListings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListings>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns a catalog listing for the current platform
 */

export function useGetListings<TData = Awaited<ReturnType<typeof getListings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListings>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetListingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Generates basic recommended listings for the current user
 */
export const generateBasicRecommendedListings = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ListingModel[]>(
      {url: `/api/v1/listings/basic-recommended`, method: 'POST', signal
    },
      options);
    }




export const getGenerateBasicRecommendedListingsMutationKey = () => ['generateBasicRecommendedListings'] as const;

export const getGenerateBasicRecommendedListingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateBasicRecommendedListings>>, TError,void, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof generateBasicRecommendedListings>>, TError,void, TContext> => {

const mutationKey = getGenerateBasicRecommendedListingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateBasicRecommendedListings>>, void> = () => {


          return  generateBasicRecommendedListings(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateBasicRecommendedListingsMutationResult = NonNullable<Awaited<ReturnType<typeof generateBasicRecommendedListings>>>

    export type GenerateBasicRecommendedListingsMutationError = ErrorType<unknown>


    /**
 * @summary Generates basic recommended listings for the current user
 */
export const useGenerateBasicRecommendedListings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateBasicRecommendedListings>>, TError,void, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateBasicRecommendedListings>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGenerateBasicRecommendedListingsMutationOptions(options), queryClient);
    }
    /**
 * @summary Returns a catalog listing for the current platform
 */
export const getPublicListings = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ListingModel[]>(
      {url: `/api/v1/listings/public`, method: 'GET', signal
    },
      options);
    }




export const getGetPublicListingsQueryKey = () => {
    return [
    `/api/v1/listings/public`
    ] as const;
    }


export const getGetPublicListingsQueryOptions = <TData = Awaited<ReturnType<typeof getPublicListings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicListings>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicListingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicListings>>> = ({ signal }) => getPublicListings(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicListings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicListingsQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicListings>>>
export type GetPublicListingsQueryError = ErrorType<unknown>


export function useGetPublicListings<TData = Awaited<ReturnType<typeof getPublicListings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicListings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicListings>>,
          TError,
          Awaited<ReturnType<typeof getPublicListings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicListings<TData = Awaited<ReturnType<typeof getPublicListings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicListings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicListings>>,
          TError,
          Awaited<ReturnType<typeof getPublicListings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicListings<TData = Awaited<ReturnType<typeof getPublicListings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicListings>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns a catalog listing for the current platform
 */

export function useGetPublicListings<TData = Awaited<ReturnType<typeof getPublicListings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicListings>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicListingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Returns a catalog listing for the current platform
 */
export const getListing = (
    id: string,
    params?: GetListingParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ListingModel>(
      {url: `/api/v1/listings/${id}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetListingQueryKey = (id: string,
    params?: GetListingParams,) => {
    return [
    `/api/v1/listings/${id}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetListingQueryOptions = <TData = Awaited<ReturnType<typeof getListing>>, TError = ErrorType<unknown>>(id: string,
    params?: GetListingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListing>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetListingQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getListing>>> = ({ signal }) => getListing(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getListing>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetListingQueryResult = NonNullable<Awaited<ReturnType<typeof getListing>>>
export type GetListingQueryError = ErrorType<unknown>


export function useGetListing<TData = Awaited<ReturnType<typeof getListing>>, TError = ErrorType<unknown>>(
 id: string,
    params: undefined |  GetListingParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListing>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getListing>>,
          TError,
          Awaited<ReturnType<typeof getListing>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetListing<TData = Awaited<ReturnType<typeof getListing>>, TError = ErrorType<unknown>>(
 id: string,
    params?: GetListingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListing>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getListing>>,
          TError,
          Awaited<ReturnType<typeof getListing>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetListing<TData = Awaited<ReturnType<typeof getListing>>, TError = ErrorType<unknown>>(
 id: string,
    params?: GetListingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListing>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns a catalog listing for the current platform
 */

export function useGetListing<TData = Awaited<ReturnType<typeof getListing>>, TError = ErrorType<unknown>>(
 id: string,
    params?: GetListingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListing>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetListingQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * The catalog reads scope a listing to the patient's own location, so a shared link to an
 * item sold elsewhere resolves to a bare not-found. This says where it is sold, so the app
 * can offer to switch location instead of dead-ending.
 * @summary Returns the locations a listing is purchasable at.
 */
export const getListingLocationAvailability = (
    id: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DisplayListingLocationAvailability>(
      {url: `/api/v1/listings/${id}/location-availability`, method: 'GET', signal
    },
      options);
    }




export const getGetListingLocationAvailabilityQueryKey = (id: string,) => {
    return [
    `/api/v1/listings/${id}/location-availability`
    ] as const;
    }


export const getGetListingLocationAvailabilityQueryOptions = <TData = Awaited<ReturnType<typeof getListingLocationAvailability>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListingLocationAvailability>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetListingLocationAvailabilityQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getListingLocationAvailability>>> = ({ signal }) => getListingLocationAvailability(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getListingLocationAvailability>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetListingLocationAvailabilityQueryResult = NonNullable<Awaited<ReturnType<typeof getListingLocationAvailability>>>
export type GetListingLocationAvailabilityQueryError = ErrorType<void>


export function useGetListingLocationAvailability<TData = Awaited<ReturnType<typeof getListingLocationAvailability>>, TError = ErrorType<void>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListingLocationAvailability>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getListingLocationAvailability>>,
          TError,
          Awaited<ReturnType<typeof getListingLocationAvailability>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetListingLocationAvailability<TData = Awaited<ReturnType<typeof getListingLocationAvailability>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListingLocationAvailability>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getListingLocationAvailability>>,
          TError,
          Awaited<ReturnType<typeof getListingLocationAvailability>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetListingLocationAvailability<TData = Awaited<ReturnType<typeof getListingLocationAvailability>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListingLocationAvailability>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the locations a listing is purchasable at.
 */

export function useGetListingLocationAvailability<TData = Awaited<ReturnType<typeof getListingLocationAvailability>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListingLocationAvailability>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetListingLocationAvailabilityQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Returns the collection of packages tied to a particular listing
 */
export const getListingPackages = (
    id: string,
    params?: GetListingPackagesParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PackageModel[]>(
      {url: `/api/v1/listings/${id}/packages`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetListingPackagesQueryKey = (id: string,
    params?: GetListingPackagesParams,) => {
    return [
    `/api/v1/listings/${id}/packages`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetListingPackagesQueryOptions = <TData = Awaited<ReturnType<typeof getListingPackages>>, TError = ErrorType<unknown>>(id: string,
    params?: GetListingPackagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListingPackages>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetListingPackagesQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getListingPackages>>> = ({ signal }) => getListingPackages(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getListingPackages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetListingPackagesQueryResult = NonNullable<Awaited<ReturnType<typeof getListingPackages>>>
export type GetListingPackagesQueryError = ErrorType<unknown>


export function useGetListingPackages<TData = Awaited<ReturnType<typeof getListingPackages>>, TError = ErrorType<unknown>>(
 id: string,
    params: undefined |  GetListingPackagesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListingPackages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getListingPackages>>,
          TError,
          Awaited<ReturnType<typeof getListingPackages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetListingPackages<TData = Awaited<ReturnType<typeof getListingPackages>>, TError = ErrorType<unknown>>(
 id: string,
    params?: GetListingPackagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListingPackages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getListingPackages>>,
          TError,
          Awaited<ReturnType<typeof getListingPackages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetListingPackages<TData = Awaited<ReturnType<typeof getListingPackages>>, TError = ErrorType<unknown>>(
 id: string,
    params?: GetListingPackagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListingPackages>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the collection of packages tied to a particular listing
 */

export function useGetListingPackages<TData = Awaited<ReturnType<typeof getListingPackages>>, TError = ErrorType<unknown>>(
 id: string,
    params?: GetListingPackagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListingPackages>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetListingPackagesQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Returns the treatment expectations tied to a particular listing
 */
export const getListingExpectations = (
    id: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PackageListingExpectationModel[]>(
      {url: `/api/v1/listings/${id}/expectations`, method: 'GET', signal
    },
      options);
    }




export const getGetListingExpectationsQueryKey = (id: string,) => {
    return [
    `/api/v1/listings/${id}/expectations`
    ] as const;
    }


export const getGetListingExpectationsQueryOptions = <TData = Awaited<ReturnType<typeof getListingExpectations>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListingExpectations>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetListingExpectationsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getListingExpectations>>> = ({ signal }) => getListingExpectations(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getListingExpectations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetListingExpectationsQueryResult = NonNullable<Awaited<ReturnType<typeof getListingExpectations>>>
export type GetListingExpectationsQueryError = ErrorType<unknown>


export function useGetListingExpectations<TData = Awaited<ReturnType<typeof getListingExpectations>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListingExpectations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getListingExpectations>>,
          TError,
          Awaited<ReturnType<typeof getListingExpectations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetListingExpectations<TData = Awaited<ReturnType<typeof getListingExpectations>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListingExpectations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getListingExpectations>>,
          TError,
          Awaited<ReturnType<typeof getListingExpectations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetListingExpectations<TData = Awaited<ReturnType<typeof getListingExpectations>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListingExpectations>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the treatment expectations tied to a particular listing
 */

export function useGetListingExpectations<TData = Awaited<ReturnType<typeof getListingExpectations>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListingExpectations>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetListingExpectationsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Returns a collection of the media items attached to a listing
 */
export const getListingMedia = (
    id: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ListingMediaModel[]>(
      {url: `/api/v1/listings/${id}/media`, method: 'GET', signal
    },
      options);
    }




export const getGetListingMediaQueryKey = (id: string,) => {
    return [
    `/api/v1/listings/${id}/media`
    ] as const;
    }


export const getGetListingMediaQueryOptions = <TData = Awaited<ReturnType<typeof getListingMedia>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListingMedia>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetListingMediaQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getListingMedia>>> = ({ signal }) => getListingMedia(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getListingMedia>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetListingMediaQueryResult = NonNullable<Awaited<ReturnType<typeof getListingMedia>>>
export type GetListingMediaQueryError = ErrorType<unknown>


export function useGetListingMedia<TData = Awaited<ReturnType<typeof getListingMedia>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListingMedia>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getListingMedia>>,
          TError,
          Awaited<ReturnType<typeof getListingMedia>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetListingMedia<TData = Awaited<ReturnType<typeof getListingMedia>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListingMedia>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getListingMedia>>,
          TError,
          Awaited<ReturnType<typeof getListingMedia>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetListingMedia<TData = Awaited<ReturnType<typeof getListingMedia>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListingMedia>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns a collection of the media items attached to a listing
 */

export function useGetListingMedia<TData = Awaited<ReturnType<typeof getListingMedia>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListingMedia>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetListingMediaQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Returns a collection of listings that are related to this one
 */
export const getRelatedListings = (
    id: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ListingModel[]>(
      {url: `/api/v1/listings/${id}/related`, method: 'GET', signal
    },
      options);
    }




export const getGetRelatedListingsQueryKey = (id: string,) => {
    return [
    `/api/v1/listings/${id}/related`
    ] as const;
    }


export const getGetRelatedListingsQueryOptions = <TData = Awaited<ReturnType<typeof getRelatedListings>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRelatedListings>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRelatedListingsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRelatedListings>>> = ({ signal }) => getRelatedListings(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRelatedListings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRelatedListingsQueryResult = NonNullable<Awaited<ReturnType<typeof getRelatedListings>>>
export type GetRelatedListingsQueryError = ErrorType<unknown>


export function useGetRelatedListings<TData = Awaited<ReturnType<typeof getRelatedListings>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRelatedListings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRelatedListings>>,
          TError,
          Awaited<ReturnType<typeof getRelatedListings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRelatedListings<TData = Awaited<ReturnType<typeof getRelatedListings>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRelatedListings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRelatedListings>>,
          TError,
          Awaited<ReturnType<typeof getRelatedListings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRelatedListings<TData = Awaited<ReturnType<typeof getRelatedListings>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRelatedListings>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns a collection of listings that are related to this one
 */

export function useGetRelatedListings<TData = Awaited<ReturnType<typeof getRelatedListings>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRelatedListings>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRelatedListingsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Returns the practice-uploaded before/after photo pairs for a listing, ordered so the pairs
most like the requesting patient come first.
 */
export const getListingBeforeAfters = (
    id: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DisplayPatientTreatmentBeforeAfterPairResponse[]>(
      {url: `/api/v1/listings/${id}/before-afters`, method: 'GET', signal
    },
      options);
    }




export const getGetListingBeforeAftersQueryKey = (id: string,) => {
    return [
    `/api/v1/listings/${id}/before-afters`
    ] as const;
    }


export const getGetListingBeforeAftersQueryOptions = <TData = Awaited<ReturnType<typeof getListingBeforeAfters>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListingBeforeAfters>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetListingBeforeAftersQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getListingBeforeAfters>>> = ({ signal }) => getListingBeforeAfters(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getListingBeforeAfters>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetListingBeforeAftersQueryResult = NonNullable<Awaited<ReturnType<typeof getListingBeforeAfters>>>
export type GetListingBeforeAftersQueryError = ErrorType<unknown>


export function useGetListingBeforeAfters<TData = Awaited<ReturnType<typeof getListingBeforeAfters>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListingBeforeAfters>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getListingBeforeAfters>>,
          TError,
          Awaited<ReturnType<typeof getListingBeforeAfters>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetListingBeforeAfters<TData = Awaited<ReturnType<typeof getListingBeforeAfters>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListingBeforeAfters>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getListingBeforeAfters>>,
          TError,
          Awaited<ReturnType<typeof getListingBeforeAfters>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetListingBeforeAfters<TData = Awaited<ReturnType<typeof getListingBeforeAfters>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListingBeforeAfters>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the practice-uploaded before/after photo pairs for a listing, ordered so the pairs
most like the requesting patient come first.
 */

export function useGetListingBeforeAfters<TData = Awaited<ReturnType<typeof getListingBeforeAfters>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListingBeforeAfters>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetListingBeforeAftersQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Returns no content because the quarterly RepeatMD giveaway has been retired.
 */
export const getRepeatMDOffer = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/offers`, method: 'GET', signal
    },
      options);
    }




export const getGetRepeatMDOfferQueryKey = () => {
    return [
    `/api/v1/offers`
    ] as const;
    }


export const getGetRepeatMDOfferQueryOptions = <TData = Awaited<ReturnType<typeof getRepeatMDOffer>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRepeatMDOffer>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRepeatMDOfferQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRepeatMDOffer>>> = ({ signal }) => getRepeatMDOffer(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRepeatMDOffer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRepeatMDOfferQueryResult = NonNullable<Awaited<ReturnType<typeof getRepeatMDOffer>>>
export type GetRepeatMDOfferQueryError = ErrorType<void>


export function useGetRepeatMDOffer<TData = Awaited<ReturnType<typeof getRepeatMDOffer>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRepeatMDOffer>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRepeatMDOffer>>,
          TError,
          Awaited<ReturnType<typeof getRepeatMDOffer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRepeatMDOffer<TData = Awaited<ReturnType<typeof getRepeatMDOffer>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRepeatMDOffer>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRepeatMDOffer>>,
          TError,
          Awaited<ReturnType<typeof getRepeatMDOffer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRepeatMDOffer<TData = Awaited<ReturnType<typeof getRepeatMDOffer>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRepeatMDOffer>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns no content because the quarterly RepeatMD giveaway has been retired.
 */

export function useGetRepeatMDOffer<TData = Awaited<ReturnType<typeof getRepeatMDOffer>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRepeatMDOffer>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRepeatMDOfferQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






